<template>
  <div class="quiz" id="quiz" data-toggle="buttons">
    <b-row>
      <b-col lg="6" v-for="(item,i) in answers" :key="i">
        <b-button
          :variant="variant"
          @click="answer(item)"
          v-model="myAnswers"
          class="element-animation1 btn-block answer"
          pill
        >
            {{ item.answer }}</b-button
        >

        </b-col
      >
    </b-row>
  </div>
</template>

<script>
export default {
  // props: {
  //   answers:[],
  // },
  props:['answers','myAnswers'],
  data() {
    return {
      variant: "outline-dark",
      myAnswers:[],
    };
  },
  watch: {
			myAnswers() {
				this.$emit('update', this.myAnswers)
			}
		},
  methods:{
    answer(item){
      this.myAnswers.push(item);
      // console.log(this.$props.my)
    }
  }
};
</script>

<style>
</style>